<template>
  <div>
    <div v-if="!isLoad">
      <v-main style="padding: 0px" class="bg-[#f7fafb] dark-bg-default">
        <v-col class="custom-tabs">
          <v-tabs
            v-show="!hideAllTabs"
            v-model="tabs"
            align-with-title
            :color="$vuetify.theme.currentTheme.primary"
          >
            <v-tab
              v-for="(tab, index) in tabItems"
              :key="index"
              class="mr-12 ml-0"
              v-show="tab.key !== 'AddLead' || canAddLead"
              :color="$vuetify.theme.currentTheme.primary"
            >
              {{ tab.name }}
            </v-tab>
            <v-tabs-slider color="#32D583"></v-tabs-slider>
          </v-tabs>
        </v-col>
        <component
          @handleEditAndChangeTab="handleEditAndChangeTabMethod"
          @search="handleSearch"
          :is="currentTab"
          :useCaseLeadConfig="useCaseLeadConfig"
          :useCaseTaskConfig="useCaseTaskConfig"
          :tabSwitch="handleTabSwitch"
          :lead-steps="leadSteps"
          :task-steps="taskSteps"
          :users="users"
          :companies="companies"
          :fetchCompanies="fetchCompanies"
          :editItems="editItems"
        >
        </component>
      </v-main>
    </div>
    <div
      v-else
      class="absolute w-full h-screen flex-col items-center flex justify-center"
    >
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
  </div>
</template>

<script>
import Leads from "@/components/Workforce/LeadManagement/LeadsTable.vue";
import AddLead from "@/components/Workforce/LeadManagement/AddLead.vue";
import Tasks from "@/components/Workforce/LeadManagement/TaskTable.vue";
import { hasPermission } from "@/utils/common";
import permissionData from "@/utils/permissions";
import { sortDropdownOptions } from "@/utils/common";

export default {
  name: "LeadPage",
  layout: "Workforce/default",
  components: {
    Leads,
    Tasks,
    AddLead,
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      orgCode: this.$storage.getUniversal("organization_code"),
      orgLang: this.$store.state.orgLanguage,
      tabs: 0,
      leadName: "",
      leadSteps: [],
      taskSteps: [],
      users: [],
      companies: [],
      editItems: {},
      isLoad: true,
    };
  },
  watch: {
    tabs() {
      if (this.tabs !== 2) {
        this.editItems = null;
      }
    },
    "$route.params.usecase": async function (newQuery) {
      if (newQuery) {
        this.tabs = 0;
      }
    },
  },
  methods: {
    handleTabSwitch() {
      this.tabs = 0;
    },
    handleEditAndChangeTabMethod(item) {
      this.editItems = item;
      this.tabs = 2;
    },
    handleSearch(item) {
      this.fetchCompanies(item);
    },
    async fetchLeadSteps() {
      try {
        const response = await this.$axios.get(`/workforce/lead/steps`);

        const leadStepsArray = [];

        for (const key in response.data?.leadSteps) {
          if (
            Object.prototype.hasOwnProperty.call(response.data?.leadSteps, key)
          ) {
            leadStepsArray.push({
              key: key,
              value: response.data.leadSteps[key],
            });
          }
        }

        this.leadSteps = leadStepsArray;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchCompanies(searchText) {
      try {
        const params = {
          companySearch: searchText,
        };
        const response = await this.$axios.get("/workforce/allcompany", {
          params,
        });
        const companies = response.data.companies;
        this.companies = sortDropdownOptions(companies, "name");

        if (this.selectedCompanyId) {
          const selectedCompany = this.companies.find(
            (company) => company._id === this.selectedCompanyId
          );
          if (selectedCompany) {
            const selectedCompanyContacts =
              selectedCompany?.companyBranches[0]?.contacts || [];
            if (selectedCompanyContacts) {
              this.contacts = selectedCompanyContacts.map((contact) => ({
                firstName: contact.firstName,
              }));
            }
          }
        }

        this.isLoading = false;
        this.contacts = [];
        this.selectedCompanyId = "";
      } catch (error) {
        console.error(error);
      }
    },
    fetchUser() {
      this.$axios
        .get(`/workforce/users`, {
          params: {
            limit: 100,
          },
        })
        .then((res) => {
          this.users = res.data.users.map((user) => ({
            ...user,
            id: user._id,
            full_name: `${user.firstName || ""} ${user.lastName || ""}`,
          }));
          this.users.push({
            id: null,
            _id: null,
            firstName: "Unassigned",
          });
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
    async fetchTaskSteps() {
      try {
        const response = await this.$axios.get(`/workforce/task/steps`);

        const taskStepsArray = [];

        for (const key in response.data?.taskSteps) {
          if (
            Object.prototype.hasOwnProperty.call(response.data?.taskSteps, key)
          ) {
            taskStepsArray.push({
              key: key,
              value: response.data.taskSteps[key],
            });
          }
        }

        this.taskSteps = taskStepsArray;
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    useCaseLeadConfig() {
      const currentUsecase = this.$route.params.usecase;
      const orgConfig = this.orgLang.data || {};
      const leadModules = orgConfig.leadModules || [];
      const currentConfig = leadModules.find(
        (m) => m.useCaseType === currentUsecase
      );

      return currentConfig;
    },
    useCaseTaskConfig() {
      const currentUsecase = this.$route.params.usecase;
      const orgConfig = this.orgLang.data || {};

      const taskModules = orgConfig.taskModules || [];

      const currentConfig = taskModules.find(
        (m) => m.useCaseType === currentUsecase
      );

      return currentConfig;
    },
    currentTab() {
      return this.tabItems[this.tabs]?.component;
    },
    canAddLead() {
      return hasPermission(this.userData, permissionData.leadWrite);
    },
    canEdit() {
      return hasPermission(this.userData, permissionData.taskEdit);
    },
    haveInventoryAccess() {
      return hasPermission(this.userData, permissionData.inventoryRead);
    },
    hideAllTabs() {
      if (
        this.$route.query?.complaint_no &&
        !hasPermission(this.userData, permissionData.leadRead)
      ) {
        return (
          this.canEdit &&
          this.haveInventoryAccess &&
          this.$route.query?.complaint_no
        );
      }
      return false;
    },
    taskLable() {
      if (!this.useCaseTaskConfig) return {};
      return {
        taskTab: this.useCaseTaskConfig.tabs?.tasks,
        addTask: this.useCaseTaskConfig.tabs?.addANewTask,
      };
    },
    tabItems() {
      const taskLabel = this.taskLable;
      return [
        {
          key: "leads",
          name: this.useCaseLeadConfig?.tabs?.lead || "",
          component: "Leads",
        },
        { key: "task", name: taskLabel.taskTab, component: "Tasks" },
        {
          key: "AddLead",
          name: this.useCaseLeadConfig?.tabs?.addANewLead || "",
          component: "AddLead",
        },
      ];
    },
  },
  async mounted() {
    const query = this.$route.query;

    if (query.active_tab && query.active_tab === "complaint") this.tabs = 1;

    await this.fetchLeadSteps();
    // await this.fetchCompanies();
    await this.fetchUser();
    await this.fetchTaskSteps();
    this.isLoad = false;
  },
};
</script>
<style>
.v-main__wrap.v-content__wrap {
  padding: 0px 20px;
}

.theme--light.v-tabs .v-tab:hover::before {
  opacity: 0;
}

.theme--light.v-tabs .v-tab--active:hover::before,
.theme--light.v-tabs .v-tab--active::before {
  opacity: 0;
}

.custom-tabs {
  padding-left: 0px;
}

.v-tab {
  font-size: 16px;
}
</style>
